const nt = {
  id: 'sealink_nt',
  tenantId: 'sealink_nt',
  name: 'SeaLink NT',
  quicktravelUrl: 'https://nt-next.quicktravel.com.au',
  productTypeIDs: [30, 31], // 30=NT Ferry & Bus 31=NT Kiosk
  adjustmentCategoryId: 13, // ID of category of adjustments to show
  payments: {
    allowedPaymentTypes: [
      { id: 1, code: 'cash' },
      { id: 6, code: 'eftpos' },
      { id: 7, code: 'cheque' },
      { id: 9, code: 'amex' },
      { id: 13, code: 'on_account' },
      { id: 19, code: 'mastercard_visa' },
    ],
    defaultPaymentTypeId: 1,
  },
  countries: {
    required: true,
    promotedCountries: [14, 74, 81, 232, 158],
    requiringPostcode: [14],
  },
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 1,
  },
  receipts: {
    autoPrint: false,
    printType: 'quickets',
  },
  apiKey: '3640a6460ff730d373cd75e87dcb58eb9da289f715073963092e48cb31381b4b',
};

const qld = {
  id: 'sealink_nq',
  name: 'SeaLink NQ',
  quicktravelUrl: 'https://nq-next.quicktravel.com.au',
  productTypeIDs: [26, 27, 16, 29], // These are the ids of the Palm Is and Maggi Is product types in QT
  adjustmentCategoryId: 1, // ID of category of adjustments to show
  payments: {
    allowedPaymentTypes: [
      { id: 1, code: 'cash' },
      { id: 5, code: 'tcc_voucher' },
      { id: 6, code: 'eftpos' },
      { id: 7, code: 'cheque' },
      { id: 9, code: 'amex' },
      { id: 13, code: 'on_account' },
      { id: 19, code: 'mastercard_visa' },
      { id: 49, code: 'tsv' },
    ],
    defaultPaymentTypeId: 1,
  },
  countries: {
    required: true,
    promotedCountries: [14, 74, 81, 232, 158],
    requiringPostcode: [14],
  },
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 1,
  },
  receipts: {
    autoPrint: false,
    printType: 'quickets',
  },
  apiKey: '3640a6460ff730d373cd75e87dcb58eb9da289f715073963092e48cb31381b4b',
};

const ccc = {
  id: 'captain_cook',
  name: 'Captain Cook NSW',
  quicktravelUrl: 'https://cc-next.quicktravel.com.au',
  productTypeIDs: [10, 17, 14],
  payments: {
    allowedPaymentTypes: [
      { id: 1, code: 'cash' },
      { id: 4, code: 'on_account' },
      { id: 8, code: 'amex' },
      { id: 11, code: 'mastercard_visa' },
      { id: 13, code: 'on_account' },
      { id: 17, code: 'diners' },
      { id: 18, code: 'jcb' },
      { id: 20, code: 'eftpos' },
    ],
    defaultPaymentTypeId: 1,
  },
  countries: {
    required: true,
    promotedCountries: [14],
    requiringPostcode: [14],
  },
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 1,
  },
  receipts: {
    autoPrint: false,
    printType: 'quickets',
  },
  apiKey: '96a47854c73e43ccd1875ab62611e8ee3c9bedc79579adff18c7d43a8e6b9e75',
};

const stradbroke = {
  id: 'stradbroke',
  name: 'SeaLink SEQ',
  quicktravelUrl: 'https://stradbroke-next.quicktravel.com.au',
  productTypeIDs: [5, 8, 15],
  payments: {
    allowedPaymentTypes: [
      { id: 1, code: 'cash' },
      { id: 3, code: 'on_account' },
      { id: 6, code: 'on_account_ref' },
      { id: 8, code: 'mastercard_visa' },
      { id: 26, code: 'eftpos_debit' },
      { id: 12, code: 'eftpos_mastercard' },
      { id: 13, code: 'eftpos_visa' },
      { id: 10, code: 'eftpos_amex' },
    ],
    defaultPaymentTypeId: 1,
  },
  countries: {
    required: true,
    promotedCountries: [14],
    requiringPostcode: [14],
  },
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 1,
  },
  receipts: {
    autoPrint: false,
    printType: 'quickets',
  },
  apiKey: '89a282592121dfecef2051b4d8728f150e5a44f53cd57aa4327596411eeb638c',
};

const bruny = {
  id: 'bruny',
  name: 'SeaLink Bruny Island',
  quicktravelUrl: 'https://bruny-next.quicktravel.com.au',
  productTypeIDs: [3],
  payments: {
    allowedPaymentTypes: [
      { id: 1, code: 'cash' },
      { id: 3, code: 'on_account' },
      { id: 4, code: 'on_account_ref' },
      { id: 7, code: 'cheque' },
      { id: 24, code: 'eftpos_mastercard_visa' },
    ],
    defaultPaymentTypeId: 25,
  },
  scanningOptions: {
    specificStopId: 1,
    specificResourceId: null,
    specificVesselId: null,
    validateDeparture: true,
    validateDepartureMode: 'closest',
  },
  autoPromoCode: {
    mode: 'seasonality',
    seasonalities: {
      departureMode: 'next',
      departure: {
        route_id: 1,
        from_stop_id: 1,
      },
      mapping: {
        1: { id: 4, code: 'LIGHTFARES (SUPERSAVER)' },
        2: { id: 13, code: 'SAVER' },
      },
    },
  },
  countries: {
    required: false,
    promotedCountries: [14],
    requiringPostcode: [14],
  },
  categoryColourConfig: {
    2: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'darkblue',
      font: 'white',
    },
    3: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'lightblue',
      font: 'black',
    },
    4: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'green',
      font: 'black',
    },
    5: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'yellow',
      font: 'black',
    },
  },
  adjustmentCategoryId: 7,
  autoValidateTicket: true,
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 1,
  },
  receipts: {
    autoPrint: true,
    printType: 'albert',
  },
  apiKey: 'fb1c60b28f962e8b577a945598184762e65747b4b34b69256ba7d1f305ac5697',
};

const cc_wa = {
  id: 'captain_cook_wa',
  name: 'SeaLink WA',
  quicktravelUrl: 'https://ccwa-next.quicktravel.com.au',
  productTypeIDs: [23, 24, 28],
  payments: {
    allowedPaymentTypes: [{ id: 1, code: 'cash' }],
    defaultPaymentTypeId: 1,
  },
  countries: {
    required: false,
    promotedCountries: [14],
    requiringPostcode: [14],
  },
  categoryColourConfig: {
    2: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'darkblue',
      font: 'white',
    },
    3: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'lightblue',
      font: 'black',
    },
    4: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'green',
      font: 'black',
    },
    5: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'yellow',
      font: 'black',
    },
  },
  adjustmentCategoryId: 16,
  autoPromoCodes: [],
  autoValidateTicket: false,
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 1,
  },
  receipts: {
    autoPrint: true,
    printType: 'quickets',
  },
  apiKey: '29e7c4e6f397f8c6de9b1bddb64e4dc73da6cf66cc44dcb79db873c98bcee15e',
};

const wa_experiences = {
  id: 'wa_experiences',
  name: 'WA Experiences',
  quicktravelUrl: 'https://wa-experiences-next.quicktravel.com.au',
  productTypeIDs: [23, 24, 28],
  payments: {
    allowedPaymentTypes: [{ id: 1, code: 'cash' }],
    defaultPaymentTypeId: 1,
  },
  countries: {
    required: false,
    promotedCountries: [14],
    requiringPostcode: [14],
  },
  categoryColourConfig: {
    2: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'darkblue',
      font: 'white',
    },
    3: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'lightblue',
      font: 'black',
    },
    4: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'green',
      font: 'black',
    },
    5: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'yellow',
      font: 'black',
    },
  },
  adjustmentCategoryId: 16,
  autoPromoCodes: [],
  autoValidateTicket: false,
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 1,
  },
  receipts: {
    autoPrint: true,
    printType: 'quickets',
  },
  apiKey: '29e7c4e6f397f8c6de9b1bddb64e4dc73da6cf66cc44dcb79db873c98bcee15e',
};

const sealink_sa = {
  id: 'sealink',
  name: 'SeaLink SA',
  quicktravelUrl: 'https://kis-next.quicktravel.com.au',
  productTypeIDs: [554881950, 554881979],
  payments: {
    allowedPaymentTypes: [{ id: 1, code: 'cash' }],
    defaultPaymentTypeId: 1,
  },
  countries: {
    required: false,
    promotedCountries: [14],
    requiringPostcode: [14],
  },
  categoryColourConfig: {
    2: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'darkblue',
      font: 'white',
    },
    3: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'lightblue',
      font: 'black',
    },
    4: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'green',
      font: 'black',
    },
    5: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'yellow',
      font: 'black',
    },
  },
  adjustmentCategoryId: 750275996,
  autoPromoCodes: [],
  autoValidateTicket: false,
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 1,
  },
  receipts: {
    autoPrint: true,
    printType: 'quickets',
  },
  apiKey: 'a532b2e258c3c279789b4b97f0b7af20f817bb4647a1a7de98c82dd15a51a008',
};

const kis_tourism = {
  id: 'kis_tourism',
  name: 'KIS Tourism',
  quicktravelUrl: 'https://kis-tourism-next.quicktravel.com.au',
  productTypeIDs: [554881950, 554881979],
  payments: {
    allowedPaymentTypes: [{ id: 1, code: 'cash' }],
    defaultPaymentTypeId: 1,
  },
  countries: {
    required: false,
    promotedCountries: [14],
    requiringPostcode: [14],
  },
  categoryColourConfig: {
    2: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'darkblue',
      font: 'white',
    },
    3: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'lightblue',
      font: 'black',
    },
    4: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'green',
      font: 'black',
    },
    5: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'yellow',
      font: 'black',
    },
  },
  adjustmentCategoryId: 750275996,
  autoPromoCodes: [],
  autoValidateTicket: false,
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 1,
  },
  receipts: {
    autoPrint: true,
    printType: 'quickets',
  },
  apiKey: 'a532b2e258c3c279789b4b97f0b7af20f817bb4647a1a7de98c82dd15a51a008',
};

const fraser = {
  id: 'fraser',
  name: "SeaLink K'gari",
  quicktravelUrl: 'https://kgari-next.quicktravel.com.au',
  productTypeIDs: [2],
  adjustmentCategoryId: 1,
  payments: {
    allowedPaymentTypes: [{ id: 1, code: 'cash' }],
    defaultPaymentTypeId: 1,
  },
  countries: {
    required: true,
    promotedCountries: [14],
    requiringPostcode: [14],
  },
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 1,
  },
  autoValidateTicket: false,
  apiKey: 'b9faa32aa7fbed51ed9c6ff474de4624fade33bb185c16806514eca4ab508f32',
};

export default {
  tenants: [
    nt,
    qld,
    ccc,
    stradbroke,
    bruny,
    cc_wa,
    wa_experiences,
    sealink_sa,
    kis_tourism,
    fraser,
  ],
  printingEnabled: true,
  debugEvents: false,
  rollbar: {
    accessToken: '244053c716364af1a39217cb3cafae96',
    enabled: true,
    environment: 'next',
  },
  datadog: {
    environment: 'stage',
    service: 'quicktickets-web-next',
    applicationId: 'ac90443c-2836-4ed2-8a7e-9a0dad22c441',
    clientToken: 'pubfaeb9fcfacb936e85c3ef987ef0b5411',
  },
  gitSha: null,
  showEnv: true,
  authServiceURL: 'https://auth-next.quicktravel.com.au',
  environment: 'next',
  guestLinkURL: 'https://guestlink-next.quicktravel.com.au',
  oktaIssuer: 'https://kelsian.okta.com/oauth2/aus2r719unt8dKcPH697',
  oktaClientId: '0oa4kgnozybZZIztt697',
  oktaAppBase: 'https://quicktickets-web-next.quicktravel.com.au',
  oktaEnabled: true,
  googleTagManagerId: 'G-6611Q3899T',
};
